import React from 'react'
import { ScrollView, View } from 'react-native'

import Clipboard from '@react-native-clipboard/clipboard'
import { useToast } from '@zet/common/components/toast'
import { Icon, colors } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B2, B3, B5, H5, SH3 } from '@zet/design-system/typography'

import Copy from '../../assets/images/icons/copy.svg'
import ApplicationSVG from '../../assets/images/statusScreens/application.svg'
import { brandsI18n } from '../../localization'
import { ExpiryAlert } from './expiryAlert'

type KycStatusProps = {
  title: string
  subTitle: string
  kycSteps: Array<{ title: string; subTitle: string; show: string[] }>
  kycType: 'STPK' | 'STPT'
  c1Id?: string
  pendingTime?: string
}

const KycStatus: React.FC<KycStatusProps> = ({
  title,
  subTitle,
  kycSteps,
  kycType,
  c1Id,
  pendingTime,
}) => {
  const toast = useToast()

  const filteredSteps =
    kycSteps?.filter((step) => step?.show?.includes?.(kycType)) || []

  const copyToClipboard = () => {
    Clipboard.setString(c1Id)
    toast?.show({
      heading: brandsI18n.t('axis.c1IdCopied'),
      intent: 'success',
    })
  }

  return (
    <Stack className="flex-1">
      <ScrollView>
        <H5 className="m-3">{title}</H5>
        <B2 className="mx-3 mb-4 text-justify">{subTitle}</B2>

        {filteredSteps?.map((step, index) => (
          <XStack className="mx-3" key={index}>
            <Stack className="mr-2">
              <Stack className="border-grays-30 h-4 w-4 rounded-full border-2">
                <ApplicationSVG />
              </Stack>
              {filteredSteps.length - 1 > index && (
                <Stack className="border-grays-30 -mb-2 ml-2.5 h-8 border-l-4" />
              )}
            </Stack>
            <Stack>
              {!!step?.title && <SH3>{step.title ?? ''}</SH3>}
              {!!step?.subTitle && (
                <B3 className="text-grays-70">{step.subTitle ?? ''}</B3>
              )}
            </Stack>
          </XStack>
        ))}
        <Stack className="my-3">
          <ExpiryAlert pendingTime={pendingTime} />
        </Stack>
      </ScrollView>
      {Boolean(c1Id) && (
        <Stack className="m-3">
          <B2 className="text-grays-60 my-1">
            {brandsI18n.t('axis.c1IdTitle')}
          </B2>
          <XStack
            className="border-grays-30 rounded border px-3 py-2"
            style={{ gap: 8 }}
          >
            <SH3 className="flex-1">{c1Id}</SH3>
            <Icon type={'Tick'} color={colors.success[100]} />
            <View className="border-grays-30  rounded-md border-r-2" />
            <Pressable
              onPress={copyToClipboard}
              className="flex-row"
              style={{ gap: 8 }}
            >
              <Copy />
              <SH3 className="text-primary-100 ">
                {brandsI18n.t('axis.c1IdCopy')}
              </SH3>
            </Pressable>
          </XStack>
          <B5 className="text-grays-60 mt-1.5">
            {brandsI18n.t('axis.c1IdDescription')}
          </B5>
        </Stack>
      )}
    </Stack>
  )
}

export default KycStatus
